module.exports = __webpack_public_path__ + "img/pethouse21.48ee43ee.jpg";